import React from 'react'
import { Text, Title } from '../presentation/Text'
import { useStepsActions, useStepsState } from '@btime/react-contexts'
import FlexGrid, { FlexCol } from '../structure/FlexGrid'
import PageHeaderPanel from '../presentation/PageHeaderPanel'
import Separator from '../helpers/Separator'
import StepButtons from './StepButtons'
import { COLORS } from '@btime/constants'
import UndoButton from './UndoButton'

const StepHeader = ({ t }) => {
  const { currentStep } = useStepsState()
  const { goToPrevious } = useStepsActions()

  const { title, subtitle } = currentStep

  if (currentStep.fullScreen) {
    return (
      <PageHeaderPanel
        _leftIcon="BsArrowLeftShort"
        _leftAction={goToPrevious}
        title={t(title)}
        mediumPadding
        noContainer
        side={
          <FlexGrid>
            <UndoButton color={COLORS.white} />
            <Separator vertical weight={10} />
            <StepButtons color={COLORS.white} />
          </FlexGrid>
        }
      />
    )
  }

  return (
    <div>
      <FlexGrid justify="space-between" gutter={0.5}>
        <FlexCol flex={1}>
          <Title size="h3" noMargin>
            {t(title)}
          </Title>
        </FlexCol>

        <FlexCol hideOn="sm">
          <UndoButton />
          <StepButtons />
        </FlexCol>
      </FlexGrid>

      <Separator weight={2} />

      <Text color={COLORS.dark3}>{t(subtitle)}</Text>
    </div>
  )
}

export default StepHeader
